import React from "react";
import homebg from "../img/hero/hero-bg-4.jpg";
import shape2 from "../img/hero/shape-2.png";
import shape3 from "../img/hero/shape-3.png";

import taxAssistMockup from "../img/screen/splash-screen-1.png";

const Hero = () => {
    return (
        <>
            <div
                id="apork-hero"
                className="apork-hero-area hero-bg position-relative"
                style={{background: `url('${homebg}')`}}
            >
                <div className="hero-style-shape">
                    <img className="style-shape shape-2" src={shape2} alt="imgshape"/>
                    <img
                        className="style-shape aporkrot shape-3"
                        src={shape3}
                        alt="imgshape"
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-8 col-md-12">
                            <div className="hero-content">
                                <h2>
                                    Welcome to UK Tax & Salary Assist
                                </h2>
                                <p>
                                    UK Tax & Salary Assist is an independent tax assistance app powered by Innovotech Solutions Ltd, helping users calculate UK taxes, salary breakdowns, and financial planning.
                                </p>
                                <p>
                                    We provide accurate tax calculations based on publicly available UK tax guidelines. Please consult a professional for personalized tax advice.
                                </p>
                                <p>
                                    If you need assistance, feel free to reach out to us at <strong>info@websafe365.com</strong>.
                                </p>
                                <div className="hero-btn">
                                    <a href="/terms-and-conditions" className="btn btn-primary">
                                        Terms & Conditions
                                    </a>
                                    <a href="/privacy-policy" className="btn btn-secondary ml-3">
                                        Privacy Policy
                                    </a>
                                    <a href="mailto:info@websafe365.com" className="btn btn-secondary ml-3">
                                        Contact Support
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 offset-xl-1 col-lg-4 wow fadeInRight">
                            <div className="hero-mobile-img">
                                <img src={taxAssistMockup} alt="UK Tax Assist App Screens"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Hero;
